/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_StartInputs */

const en_us2_body_assessment_start = /** @type {(inputs: Body_Assessment_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take the photos`)
};

const pt_br2_body_assessment_start = /** @type {(inputs: Body_Assessment_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tirar as fotos`)
};

const es_419_body_assessment_start = /** @type {(inputs: Body_Assessment_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tomar las fotos`)
};

const pt_pt2_body_assessment_start = /** @type {(inputs: Body_Assessment_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tirar as fotos`)
};

const fr_fr2_body_assessment_start = /** @type {(inputs: Body_Assessment_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prendre les photos`)
};

const de_de2_body_assessment_start = /** @type {(inputs: Body_Assessment_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotos machen`)
};

const it_it2_body_assessment_start = /** @type {(inputs: Body_Assessment_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scatta le foto`)
};

/**
* | output |
* | --- |
* | "Take the photos" |
*
* @param {Body_Assessment_StartInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_start = /** @type {((inputs?: Body_Assessment_StartInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_StartInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_start(inputs)
	if (locale === "es-419") return es_419_body_assessment_start(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_start(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_start(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_start(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_start(inputs)
	return en_us2_body_assessment_start(inputs)
});
export { body_assessment_start as "body-assessment.start" }